import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi';
 import './style.css'; 
 let SolutionRiskCoreCard=(props)=> {
    return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  Solution Risk ScoreCard 
  </h4>
        <br></br>
        <h6 id="h6">
  
  Solution risk scorecard evaluates if the risks of using the solution for the intended customer / user is acceptable This is the risk which happens when the solution works as designed. We are not evaluating risk of service outage here.
  
  </h6>
        <div id='divL'>
          <table id='tableAll'>
            <thead>
              <tr>
                <th scope="col">Risk</th>
                <th scope="col">Select All That Apply</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Risk">No Perceive Or Real Risk</td>
                <td data-label="Select All That Apply">
                  <input type="checkbox"></input>
                </td>
              </tr>
              <tr>
                <td data-label="Risk">user confcern of receiving email as a result of purchasing service</td>
                <td data-label="Select All That Apply">
                  <input type="checkbox"></input>
                </td>
              </tr>
              <tr>
                <td data-label="Risk">Other legal law Suit Risk</td>
                <td data-label="Select All That Apply">
                  <input type="checkbox"></input>
                </td>
              </tr>
              <tr>
                <td data-label="Risk">Total</td>
                <td data-label="Select All That Apply">
                  <input type='text' placeholder="Locked" id="lockedInput"></input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/RevenewScore')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/fundingScore')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default SolutionRiskCoreCard;